import { Component, OnInit, TemplateRef} from '@angular/core';
import { Cliente } from '../../../models/cliente';
import { ClienteService } from '../../../services/cliente.service';
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Bodega } from '../../../models/bodega';
import { BodegaService } from '../../../services/bodega.service';
import { SessionService } from '../../../services/session.service';
import { PlanAcumulativo } from '../../../models/plan-acumulativo';
import * as moment from 'moment';
import { SweetMessage } from '../../../config/sweet-message';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { PlanAcumulativoDetalle } from '../../../models/plan-acumulativo-detalle';
import { Validation } from '../../../config/validation';
import { TipoDocumento } from '../../../models/tipo-documento';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { ParametroService } from '../../../services/parametro.service';
import { PreciosModalComponent } from '../../modals/precios-modal/precios-modal.component';
import { PrecioAdicional } from '../../../models/precio_adicional';
import { PlanAcumulativoService } from '../../../services/plan-acumulativo.service';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';

@Component({
  selector: 'app-plan-acumulativo-add',
  templateUrl: './plan-acumulativo-add.component.html',
  styleUrls: ['./plan-acumulativo-add.component.css'],
  providers: [
	  ClienteService,
	  BodegaService,
	  TipoComprobanteService,
	  ParametroService,
	  PlanAcumulativoService,
	  ImpuestoPorcentajeService

	]
})
export class PlanAcumulativoAddComponent implements OnInit {
	public cliente: Cliente;
	public loading: boolean;
	public bsModalRef: BsModalRef;
	public bodegas: Array<Bodega>;
	public plan: PlanAcumulativo;
	public fecha_caducidad;
	public fecha_MesAnt;
	public msgSweet: SweetMessage;
	public vl: Validation;
	public tipos: Array<TipoDocumento>;
	public Identif: string;
	public Mod_FactElec: string;
	public Mod_Inventario: string;
	public IVA: number;
	public IVA_PARAM: number;
	public is_precios: boolean;
	public detalle: String;
	public plan_detalle: PlanAcumulativoDetalle;
	public PreciosAdd: PrecioAdicional;
	public SECUENCIAL: number;
	public is_precio_unitario_editable: boolean;
	public parametros: Array<any>
    public iva_id : number;
	public iva_vigente:boolean;
	public iva_porcentaje : any;


  	constructor(
		  public clienteService: ClienteService,
		  private modalService: BsModalService,
		  public bodegaService: BodegaService,
		  public ss: SessionService,
		  public tipoComprobanteService: TipoComprobanteService,
		  private parametroService: ParametroService,
		  private planAcumulativoService: PlanAcumulativoService,
		  public impuestoPorcentajeService: ImpuestoPorcentajeService

	  ) {
		this.cliente = new Cliente();
		this.loading = false;
		this.bodegas = [];
		this.plan = new PlanAcumulativo();
		this.fecha_caducidad = moment(this.fecha_caducidad);
		this.fecha_MesAnt = moment(this.fecha_MesAnt);
		this.msgSweet = new SweetMessage();
		this.vl = new Validation();
		this.tipos = [];
		this.Identif = "";
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.Mod_Inventario = this.ss.getData("mod_inventario");
		this.IVA = 0;
		this.IVA_PARAM = 0;
		this.is_precios = false;
		this.detalle = "";
		this.plan_detalle = new PlanAcumulativoDetalle();
		this.PreciosAdd = new PrecioAdicional();
		this.SECUENCIAL = 0;
		this.is_precio_unitario_editable = false;
		this.parametros = [];
        this.iva_id = 0;
		this.iva_vigente = false;
		this.iva_porcentaje = 0;
	}

  	ngOnInit() {
		let p1 = this.getBodegas();
		let p2 = this.getTiposComprobante();
		let p3 = this.getParametros();
		let p4 = this.getPreciosAdicionales();
		let p5 = this.getSecuencial();
		let p6 = this.getPrecioUnitarioEditable();
		let p7 = this.getIVA(129);

		this.loading = true;
        Promise.all([p1,p2,p3,p4,p5,p6,p7]).then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	getBodegas(){
        return new Promise((resolve, reject)=>{
            this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                res => {
                    this.bodegas = res.data;
                    resolve();
                },
                err => {
                    this.bodegas = [];
                    reject(err);
                }
            );
        });		
	}
	
	getTiposComprobante(){
        return new Promise((resolve, reject)=>{
            
            if(this.Mod_FactElec){
                this.Identif = "4,2";
            }else{
                this.Identif = "1,2";
            }

            this.tipoComprobanteService.getAll("?in[id]=" + this.Identif + "&sort=nombre").subscribe(
                res => {
                    this.tipos = res.data;
                    resolve();
                },
                err => {
                    this.tipos = [];
                    reject(err);
                }
            );
        });
	}

	getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
					this.IVA_PARAM = this.iva_porcentaje;
					this.calcularTotales();
					resolve();
				},
				err => {
					this.iva_porcentaje = 0;
					this.IVA = 0;
					this.IVA_PARAM = 0;
					reject(err);
				}
			);

			
		});
	}

	getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}
	
	getPreciosAdicionales(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_adicional_id = 16;
            this.parametroService.getById(precio_adicional_id).subscribe(
                res => {
                    this.is_precios = (res.valor.toString().trim() === "SI");
                    resolve();
                },
                err => {
                    this.is_precios = false;
                    reject(err);
                }
            );
        });
	}
	
	getSecuencial(){
		return new Promise((resolve, reject)=>{
			let secuencial_plan_id = 17;
			this.parametroService.getById(secuencial_plan_id).subscribe(
			res=>{
				this.SECUENCIAL = parseInt(res.valor);
				resolve();
			},
			err=>{
				this.SECUENCIAL = 0;
				reject(err);
			}
			);
		});
	}

	getPrecioUnitarioEditable(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_unitario_editable_id = 18;
            this.parametroService.getById(precio_unitario_editable_id).subscribe(
                res => {
                    this.is_precio_unitario_editable = (res.valor.toString().trim() === "1");
                    resolve();
                },
                err => {
                    this.is_precio_unitario_editable = false;
                    reject(err);
                }
            );
        });
    }

	onSearchCliente(event) {
        if( event.keyCode === 13 ){
			if( this.cliente.dni.toString().trim().length == 0 ){
				this.cliente = new Cliente();
				return;
			}else{
				this.clienteService.getByDni(this.cliente.dni).subscribe(
					res => {
						this.loading = false;
						if (res.length > 0) {
							this.cliente = res[0];
						}else{
							this.cliente = new Cliente();
							this.openDialogCliente();
						}
					},
					err => {
						this.loading = false;
						this.openDialogCliente();
					}
				);
			}
        }
	}
	
	openDialogCliente() {
		const initialState = {qs: "&embed=tipoidentificacion"};
		this.bsModalRef = this.modalService.show(ClienteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

        this.bsModalRef.content.sendCliente.take(1).subscribe((cliente) => {
            this.cliente = cliente;
        });
	}
	
	onSearchProducto() {
        if( !this.plan.bodega_id ){
            this.msgSweet.showMessage('error-message', "Seleccione la bodega");
            return;
        }
        
		const initialState = {bodega_id: this.plan.bodega_id};
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
			//this.sendObjectProducto(value);
			this.addProduct(value);
		});
	}
	
	addProduct(value){
		let plan_detalle = new PlanAcumulativoDetalle();

		plan_detalle.producto_id = value.id;
		plan_detalle.producto.codigo = value.codigo;
		plan_detalle.producto.nombre = value.nombre;
		plan_detalle.cantidad_stock = value.cantidad_stock;
		plan_detalle.producto.graba_iva = value.graba_iva;
		plan_detalle.producto.unidadmedida.nombre = value.unidad;
		plan_detalle.precio_unitario = parseFloat(value.precio);
		plan_detalle.cantidad = 1;
		plan_detalle.subtotal = plan_detalle.cantidad * plan_detalle.precio_unitario;

		if( parseInt(this.plan.tipo_comprobante_id.toString()) === 1 || parseInt(this.plan.tipo_comprobante_id.toString()) === 4 ){
			if( value.graba_iva === 0 ){
				plan_detalle.iva = 0;
				plan_detalle.porct_iva = 0;
			}else{
				plan_detalle.iva = plan_detalle.subtotal * this.IVA;
				plan_detalle.porct_iva = this.IVA_PARAM;
			}
		}else{
			plan_detalle.iva = 0;
			plan_detalle.porct_iva = 0;
		}
		plan_detalle.total = plan_detalle.iva + plan_detalle.subtotal;
		
		plan_detalle.usuario_id = this.ss.getData('usuario_id');
		plan_detalle.empresa_id = this.ss.getData('empresa_id');
		plan_detalle.sucursal_id = this.ss.getData('sucursal_id');

		this.plan.detalle.push(plan_detalle);

		this.calcularTotales();
	}

	setValueEntity(){
		this.plan.cliente_id = this.cliente.id;
		this.plan.fecha_caducidad = moment(this.fecha_caducidad).format("YYYY-MM-DD");

		this.plan.usuario_id = this.ss.getData('usuario_id');
		this.plan.empresa_id = this.ss.getData('empresa_id');
		this.plan.sucursal_id = this.ss.getData('sucursal_id');
	}

	onSubmit(){
		let preg = "¿Está seguro de confirmar el plan acumulativo?";
        const initialState = { Pregunta: preg, Respuesta:false };
        this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
        
        this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if( Respuesta == true ){
				this.loading = true;

				this.setValueEntity();
				this.planAcumulativoService.save(this.plan).subscribe(
					res => {
						this.plan = new PlanAcumulativo();
						this.plan_detalle = new PlanAcumulativoDetalle();
						this.cliente = new Cliente();
						this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
						
						this.getSecuencial().then(
							res => this.loading = false,
							err => this.loading = false,
						);
					},
					err => {
						this.msgSweet.showMessage('error-message',err);
						this.loading = false;
					}
				);
			}
		});
	}

	isValidForm(){
		if( this.SECUENCIAL == 0 ){
			return false;
		}
		if( this.plan.tipo_comprobante_id == "" ){
			return false;
		}
		if( this.plan.bodega_id == "" ){
			return false;
		}
		if( this.cliente.id == "" ){
			return false;
		}
		if( this.plan.detalle.length == 0 ){
			return false;
		}
		return true;
	}

	onChangeFecha(event){
        /*if(event < this.fecha_MesAnt){
            this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");            
        }*/
	}
	
	onDelete(i) {
        this.plan.detalle.splice(i, 1);
		//this.calcularFactura();
		this.calcularTotales();
	}

	verificationValue(event, plan_detalle: PlanAcumulativoDetalle, campo: string){
        if( event.target.value.trim().length === 0 ){
            if( campo === 'cantidad' ){
                plan_detalle[campo] = 1;
            }else{
                plan_detalle[campo] = 0;
            }
        }
	}
	
	changeValue(event, plan_detalle: PlanAcumulativoDetalle, campo: string){
        let dscto_valor = plan_detalle.desc_valor;
        //let dscto_porcent = plan_detalle.desc_porcent;
        let value = event.target.value;

        plan_detalle[campo] = value;

        /*if( campo === 'desc_porcent' ){
            if( plan_detalle[campo] > 100 ){
                plan_detalle[campo] = 100;
            }
		}*/

        let subtotal = (plan_detalle.cantidad * plan_detalle.precio_unitario) - plan_detalle.desc_valor;
        //let porcent_value = subtotal * (plan_detalle.desc_porcent / 100)
		//plan_detalle.subtotal = subtotal - porcent_value;
		plan_detalle.subtotal = subtotal;

		if( parseInt(this.plan.tipo_comprobante_id.toString()) === 1 || parseInt(this.plan.tipo_comprobante_id.toString()) === 4 ){
			if( plan_detalle.producto.graba_iva == false ){
				plan_detalle.iva = 0;
				plan_detalle.porct_iva = 0;
			}else{
				plan_detalle.iva = plan_detalle.subtotal * this.IVA;
				plan_detalle.porct_iva = this.IVA_PARAM;
			}
		}else{
			plan_detalle.iva = 0;
			plan_detalle.porct_iva = 0;
		}

		plan_detalle.total = plan_detalle.iva + plan_detalle.subtotal;

		//this.calcularFactura();
		this.calcularTotales();
	}
	
	calcularTotales(){
		this.plan.subtotal_iva12 = 0;
        this.plan.subtotal_iva0 = 0;
        this.plan.subt_desct_iva12 = 0;
        this.plan.subt_desct_iva0 = 0;
        this.plan.subt_desct_iva0 = 0;
		this.plan.subt_desct_iva12 = 0;
		this.plan.desc_valor = 0;
        this.plan.iva = 0;
        this.plan.total = 0;
        let tipo_comprobante_id = parseInt(this.plan.tipo_comprobante_id.toString());
		let descuento = 0;
        this.plan.detalle.forEach(obj => {
			descuento += parseFloat(obj.desc_valor.toString());
			if( (tipo_comprobante_id === 1 && obj.producto.graba_iva) || tipo_comprobante_id === 4 && obj.producto.graba_iva ){
                this.plan.subtotal_iva12 += obj.subtotal;
            }else{
                this.plan.subtotal_iva0 += obj.subtotal;
            }
		});
		this.plan.desc_valor = descuento;
        //let desc_porcent = (this.venta.desct_porcent / 100);
        //desc_porcent = Math.round(desc_porcent * 100) / 100;
        //this.venta.desct_valor = (this.venta.subtotal_iva0 + this.venta.subtotal_iva12) * desc_porcent;
        //this.venta.subt_desct_iva0 = this.venta.subtotal_iva0 - (desc_porcent * this.venta.subtotal_iva0);
        //this.venta.subt_desct_iva12 = this.venta.subtotal_iva12 - (desc_porcent * this.venta.subtotal_iva12);

        if( tipo_comprobante_id === 1 || tipo_comprobante_id === 4 ){
            this.plan.iva = Math.round((this.plan.subtotal_iva12 * this.IVA) * 100) / 100;
        }else{
            this.plan.iva = Math.round(this.plan.subtotal_iva12 * 100) / 100;
        }
        
		this.plan.total = this.plan.subtotal_iva12 + this.plan.subtotal_iva0 + this.plan.iva;
        
        //Recalcular cambio
        //this.total_pago = 0;
        //TODO: this.fpSelected.forEach(e => this.total_pago += parseFloat(e.value.toString()));
        //this.cambio = (this.total_pago > this.venta.total?(this.total_pago - this.venta.total):0);
        //this.cambio = Math.round(this.cambio * 100) / 100;
	}

	onChangeComprobante(){
		this.calcularTotales();
	}

	openModalDetalle(template: TemplateRef<any>, plan_detalle) {
        this.detalle = plan_detalle.detalle;
        this.plan_detalle = plan_detalle;
        this.bsModalRef = this.modalService.show(template);
    }

	saveDetalle(){
        this.plan_detalle.detalle = this.detalle.toString().trim();
        this.detalle  = "";
        this.bsModalRef.hide();
	}
	
	openModalPrecios(plan_detalle: PlanAcumulativoDetalle){
        const initialState = { producto_id: plan_detalle.producto_id, descripcion: plan_detalle.producto.nombre};
        this.bsModalRef = this.modalService.show(PreciosModalComponent, Object.assign({backdrop: 'static'}, {class: 'modal-sm', initialState}));

        this.bsModalRef.content.sendPrecio.take(1).subscribe((precio) => {
            this.PreciosAdd = precio;

            plan_detalle.precio_unitario = parseFloat(this.PreciosAdd.valor.toString());
			plan_detalle.subtotal = (plan_detalle.cantidad * plan_detalle.precio_unitario) - plan_detalle.desc_valor;

            this.calcularTotales();
        });
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/plan-acumulativo-add/plan-acumulativo-add.component.ts